import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Brain, Mail, Trash2, UserCheck, UserMinus } from "lucide-react";

type AprendicesBulkActionsToolbarProps = {
  selectedCount: number;
  allSelected: boolean;
  onToggleSelectAll: () => void;
  onOpenAsignarModal: () => void;
  onDesasignar: () => void;
  onEnviarCorreos: () => void;
  onRemoverDelPrograma: () => void;
  isSendingEmails: boolean;
  isRemoving: boolean;
};

export default function AprendicesBulkActionsToolbar({
  selectedCount,
  allSelected,
  onToggleSelectAll,
  onOpenAsignarModal,
  onDesasignar,
  onEnviarCorreos,
  onRemoverDelPrograma,
  isSendingEmails,
  isRemoving,
}: AprendicesBulkActionsToolbarProps) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-black/5 bg-muted/30 p-3">
      <Badge variant="secondary" className="whitespace-nowrap">
        {selectedCount} seleccionados
      </Badge>

      <Button
        size="sm"
        onClick={onToggleSelectAll}
        variant="outline"
        className="whitespace-nowrap"
      >
        <UserCheck className="h-4 w-4 mr-2" />
        {allSelected ? "Deseleccionar todos" : "Seleccionar todos"}
      </Button>

      <Button
        size="sm"
        onClick={onOpenAsignarModal}
        variant="outline"
        className="whitespace-nowrap"
      >
        <Brain className="h-4 w-4 mr-2" />
        Asignar actividades
      </Button>

      <Button
        size="sm"
        variant="danger"
        onClick={onDesasignar}
        className="whitespace-nowrap"
      >
        <UserMinus className="h-4 w-4 mr-2" />
        Desasignar
      </Button>

      <Button
        size="sm"
        variant="outline"
        onClick={onEnviarCorreos}
        disabled={isSendingEmails}
        className="whitespace-nowrap"
      >
        <Mail className="h-4 w-4 mr-2" />
        {isSendingEmails
          ? "Enviando..."
          : "Enviar correos de activación"}
      </Button>

      <Button
        size="sm"
        variant="danger"
        onClick={onRemoverDelPrograma}
        disabled={isRemoving}
        className="whitespace-nowrap"
      >
        <Trash2 className="h-4 w-4 mr-2" />
        {isRemoving ? "Removiendo..." : "Remover del programa"}
      </Button>
    </div>
  );
}

